import { INewsCategoriesResponseDto } from '@r1-frontend/api-domru/content-static/v1/news-categories';

import { IAction } from '~/src/store';
import { ERROR_TAGS, GET_TAGS, SET_TAGS } from '~/src/store/actionTypes/tags';

interface IFetchTags {
    fetching: boolean,
}
export function setTagsFetching(state: IFetchTags): IAction<typeof GET_TAGS, IFetchTags> {
    return {
        type: GET_TAGS,
        payload: state,
    };
}

interface ISetTags extends IFetchTags {
    items: INewsCategoriesResponseDto[],
}

export function setTags(state: ISetTags): IAction<typeof SET_TAGS, ISetTags> {
    return {
        type: SET_TAGS,
        payload: state,
    };
}

interface IErrorTags extends IFetchTags {
    fetchError: string,
}

export function setErrorTags(state: IErrorTags): IAction<typeof ERROR_TAGS, IErrorTags> {
    return {
        type: ERROR_TAGS,
        payload: state,
    };
}
